import axios from "axios";
import { Result } from "@/models/Result";
import { CheckChannelCampaignsData } from "@/models/campaigns/CheckChannelCampaignsData";
import { GoogleCampaign } from "@/models/campaigns/GoogleCampaign";
import { requestConfig } from "./ApiService";
import ConfigService from "../ConfigService";

export default {
  checkToken(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleCheckTokenUrl);
      const config = {
        ...requestConfig,
        params: {
          channelId: campaignId,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          resolve({
            Data: response.data.isValid,
            Message: response.data.message,
            Success: response.data.success
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  clearTemplateGoogle(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleClearChannelCampaignsUrl);
      const config = {
        ...requestConfig,
        params: {
          channelId: campaignId,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          resolve({
            Message: response.data.Message,
            Success: response.data.Status === "success"
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  connectCampaign(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleConnectCampaignUrl);
      const win = window.open(url + "?channelId=" + campaignId, "windowname1", 'width=580, height=400');
      let checkWinClosed = setInterval(function () {
        if (win && win.closed) {
          const config = {
            ...requestConfig,
            params: {
              channelId: campaignId,
            }
          };
          const checkChannelCampaignsUrl = new URL(ConfigService.googleCheckChannelCampaignsUrl);
          axios.post(checkChannelCampaignsUrl.toString(), null, config)
            .then((response) => {
              const data: CheckChannelCampaignsData = {
                adGroups: response.data.adGroups,
                campaignCount: response.data.campaignCount,
                campaigns: response.data.campaigns,
              };
              resolve({
                Data: data,
                Message: response.data.Message,
                Success: response.data.Status === "success"
              });
            })
            .catch((error) => {
              reject(error);
            });
          clearInterval(checkWinClosed);
        }
      }, 200);
    });
  },

  getGoogleCampaign(id: string): Promise<GoogleCampaign> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleCampaignUrl);
      const config = {
        ...requestConfig,
        params: {
          id,
        },
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          const result: GoogleCampaign = response.data;
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getGoogleConnectData(clientId?: number, checklistClientId?: number, message?: string): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleConnectDataUrl);
      const config = {
        ...requestConfig,
        params: {
          checklistClientId,
          clientId,
          message,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          const result: Result = response.data;
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loginCustomer(clientId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleLoginCustomerUrl);

      var w = 950;
      var h = 450;
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      var systemZoom = width / window.screen.availWidth;
      var left = (width - w) / 2 / systemZoom + dualScreenLeft
      var top = (height - h) / 2 / systemZoom + dualScreenTop

      const win = window.open(url + "?clientID=" + clientId, "windowname1", "width=" + w / systemZoom + ", height=" + h / systemZoom + ", top=" + top + ", left=" + left);
      let checkWinClosed = setInterval(function () {
        if (win && win.closed) {
          clearInterval(checkWinClosed);
          const result: Result = {
            Message: "",
            Success: true,
          };
          resolve(result);
        }
      }, 200);
    });
  },

  repairToken(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleRepairTokenUrl);
      window.open(url + "?channelId=" + campaignId, "Google", 'width=580, height=400');
    });
  },

  sendConnectMessage(email: string, clientName: string, msg: string): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.googleSendConnectMessageUrl);
      const config = {
        ...requestConfig,
        params: {
          clientName,
          email,
          msg,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          resolve({
            Message: response.data.message,
            Success: response.data.success,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
